import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Product } from '../../../../classes/Product';
import { GlobalService } from '../../../services/global.service';
import { LoginService } from '../../../services/login.service';
import { ModelService } from '../../../services/model.service';
import * as $ from 'jquery';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.css']
})
export class ProductComponent implements OnInit {

  id: number;
  contentVisible: boolean = false;
  productData: Product = new Product( );
  manufacturerName: string = '';

  availableRoles: string[] = [ 'admin', 'sales', 'manager' ];
  isAvailable: boolean = true;

  exPr = {
    existing: "Existing",
    proposed: "Proposed"
  };
  
  constructor ( 
    private route: ActivatedRoute, 
    private model: ModelService,
    private global: GlobalService,
    public loginService: LoginService ) {
    this.global.setDocumentTitle( 'Product Details' ); 
    if ( this.availableRoles.indexOf( this.loginService.userInfo.role ) === -1 ) this.isAvailable = false;
    else this.isAvailable = true;
  }

  ngOnInit ( ) { 
    this.route.params.subscribe(params => {
      this.id = +params['id'];
      this.model.getProductDataByID( this.id, ( product ) => {
        this.contentVisible = true;
        this.productData = product;
        if ( product.manufacturer ) {
          this.model.getManufacturerDataByID( product.manufacturer, ( manufacturer ) => { this.manufacturerName = manufacturer.name; });
        }
       });
    });
  }

}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/products/product/product.component.ts